import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import LogoPortal from "static/images/logo_portal_factura.png";
import LabelTitulos from "components/layout/labelTitulos";
import "components/landingPage/css/creative.css";

const styles = () => ({
  containerLogos: {
    flex: 1,
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "nowrap",
    maxHeight: "3em",
    maxWidth: "100%",
    margin: 0,
    padding: 0,
  },
  rootLogo: {
    display: "inline",
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "center",
    maxHeight: "inherit",
    maxWidth: "100%",
  },
  logo: {
    maxHeight: "inherit",
    maxWidth: "100%",
  },
});

function NavBar({ classes }) {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light fixed-top py-0 mb-0"
      id="mainNav"
    >
      <div className="container">
        <Link className={"navbar-brand"} to={"/"}>
          <div className={classes.containerLogos}>
            <div className={classes.rootLogo}>
              <img
                className={classes.logo}
                src={LogoPortal}
                alt="logo-portalfactura"
              />
            </div>
          </div>
          <LabelTitulos texto="PortalFactura" />
        </Link>
        <ul className="navbar-nav ml-auto my-2 my-lg-0">
          <li className="nav-item">
            <Link className={{ textDecoration: "none" }} to={"/login"}>
              <div className={classes.loginBottom}>
                <LabelTitulos texto="Login" />
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default withStyles(styles)(NavBar);
